export default {
  Distribution0: 0,
  Distribution1: 1,
  Distribution2: 2,
  Distribution3: 3,
  Distribution4: 4,
};
